<template>
  <div
    class="field-item-row"
  >
    <label>{{ $t('message["1412"]') }}</label>
    <div class="field-item-cell">
      <draggable
        v-model="options"
      >
        <sel-item
          v-for="(item, index) in options"
          :key="item.id"
          :option-item-data="item"
          :index="index"
          :item-data="itemData"
        />
      </draggable>
      <div
        v-if="noShowDatas.length"
        class="field-item-tip"
      >
        <a-button @click="addItem">
          {{ $t('message["1198"]') }}
        </a-button>
        <add-item
          ref="addItemDialog"
          :options="options"
        />
        <em>{{ $t('message["181"]') }}</em>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SelItem from './SelItem'
import addItem from './AddItem'
// import { cloneDeep } from 'lodash'
export default {
  components: {
    SelItem,
    addItem
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // defaultValues: cloneDeep(this.itemData.defaultvalue)
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'formDefaultDatas']),
    type () {
      return this.itemData.fieldtype
    },
    options: {
      get () {
        const { itemData = {}, type } = this
        const { options = [], defaultvalue = (type === 'radio' || type === 'select') ? '' : [] } = itemData
        options.forEach(item => {
          // item.isDefault = false
          this.$set(item, 'isDefault', false)
        })
        if (type === 'checkbox') {
          defaultvalue.forEach(item => {
            options.forEach(child => {
              if (item === child.id) {
                this.$set(child, 'isDefault', true)
              }
            })
          })
        } else if (type === 'radio' || type === 'select') {
          options.forEach(child => {
            if (itemData.defaultvalue === child.id) {
              this.$set(child, 'isDefault', true)
            } else {
              this.$set(child, 'isDefault', false)
            }
          })
        }
        return options
      },
      set (val) {
        this.itemData.options = val
      }
    },
    noShowDatas () {
      const { options } = this
      return options.filter(item => !item.isshow)
    }
  },
  watch: {
    // itemData: {
    //   handler (values) {
    //     console.log(12)
    //     const { itemData = {}, type } = this
    //     const { options = [], defaultvalue = (type === 'radio' || type === 'select') ? '' : [] } = itemData
    //     if (type === 'checkbox') {
    //       defaultvalue.forEach(item => {
    //         options.forEach(child => {
    //           if (item === child.id) {
    //             child.isDefault = true
    //           }
    //         })
    //       })
    //     } else if (type === 'radio' || type === 'select') {
    //       options.forEach(child => {
    //         if (itemData.defaultvalue === child.id) {
    //           child.isDefault = true
    //         } else {
    //           child.isDefault = false
    //         }
    //       })
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    addItem () {
      this.$refs.addItemDialog.changeVisible(true)
    }
  }
}
</script>
